import { render, staticRenderFns } from "./SmsMobilePreviewForm.vue?vue&type=template&id=2afb85ca"
import script from "./SmsMobilePreviewForm.vue?vue&type=script&lang=js"
export * from "./SmsMobilePreviewForm.vue?vue&type=script&lang=js"
import style0 from "./SmsMobilePreviewForm.vue?vue&type=style&index=0&id=2afb85ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports